import React from 'react'
import useNewPlaybar from 'utils/hooks/useNewPlaybar'
import LegacyPlaybar from './Playbar'
import NewPlaybar from './NewPlaybar'
import PlaybarWithRollout from './PlaybarWithRollout'

/**
 * Entry point for the playbar.
 *
 * Users in the `new_playbar` Statsig gate get the redesigned playbar; everyone
 * else keeps the legacy one. The responsive rollout wraps that independent
 * choice, so either implementation can use the canonical breakpoints without
 * changing which playbar the user receives.
 */
const PlaybarContent = () => {
  const isNewPlaybarEnabled = useNewPlaybar()

  return isNewPlaybarEnabled ? <NewPlaybar /> : <LegacyPlaybar />
}

const Playbar = () => (
  <PlaybarWithRollout>
    <PlaybarContent />
  </PlaybarWithRollout>
)

export default Playbar
